import styled from 'styled-components';
import { Modal } from 'antd';

export const StyledTaskActivityPreview = styled(Modal)`
  max-width: 100%;
  .ant-modal-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .ant-modal-body {
      height: 100%;
      overflow-y: auto;

      .expanded-screen-button {
        display: none !important;
      }
    }
  }
`;
